module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "center",
    attrs: {
      "id": "chap1"
    }
  }, [_c('a', {
    attrs: {
      "id": "start"
    }
  }, [_vm._v("Prologue")])]), _c('a', {
    attrs: {
      "id": "start"
    }
  }, [_c('p', {
    staticClass: "noind",
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_c('i', [_vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RMS ARE IMPORTANT. THEY")]), _vm._v(" reach for things, they hug, they lift and carry, they perform tasks, they wave hello and good-bye.")])]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_c('i', [_vm._v("Legs are important. They move a body from place to place, they pedal, they drive a car, they dance, they jog, they kick a football, they jump.")])]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_c('i', [_vm._v("A mouth talks, eats, drinks, kisses, argues, smiles.")])]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_c('i', [_vm._v("A nose sneezes and smells roses and cabbage.")])]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_c('i', [_vm._v("Ears hear music and conversation and bells and train whistles and babies crying.")])]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_c('i', [_vm._v("Eyes see things, cry, wink. Eyes reflect the soul.")])]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_c('i', [_vm._v("But it is the mind that matters most. When the mind is lost,")]), _vm._v(" all "), _c('i', [_vm._v("is lost.")])]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_c('i', [_vm._v("A mind is a terrible thing to lose.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ace782ca","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/4chap1.vue
// module id = 75
// module chunks = 0